import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { trackPromise } from "react-promise-tracker";
import { Helmet } from "react-helmet";
import { Row, Col } from "reactstrap";
import Select from 'react-select';  // Import react-select for searchable dropdowns
import axios from 'axios';
import Table from "./../../components/general/Table/Table";
import Title from "./../../components/general/AdminPageTitle/AdminPageTitle";
import Loading from "../../components/wrapper/Loading/Loading";

const config = {
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true
};

class InventoryPage extends Component {
  state = {
    inventoryTableData: [],
    dataToExport: [],
    cities: [],
    makes: [],
    selectedCities: [],  // Store multiple selected cities
    selectedMake: "",
    isLoading: true,
    searchValue: '',
    noDataFound: false // Track if no data is found
  };

  constructor(props) {
    super(props);
    this.getInventoryData();
  }

  getInventoryData = () => {
    const { selectedCities, selectedMake } = this.state;

    // Show loader when fetching data
    this.setState({ isLoading: true, noDataFound: false });

    // Construct query parameters for cities and make
    let query = new URLSearchParams();

    // Handling multiple cities (send them as an array of parameters)
    if (selectedCities.length > 0) {
      selectedCities.forEach(city => query.append("city", city.value));
    }

    if (selectedMake) {
      query.append("make", selectedMake);
    }

    trackPromise(
      axios
        .get(`${process.env.REACT_APP_API_HOST}/truck/unassigned?${query.toString()}`, { withCredentials: true })
        .then((response) => {
          const unassigned_trucks = response.data.unassigned_trucks.map((truck) => {
            // Include the vendor email here as part of the row data
            return [
              truck.vendor_id,
              truck.vendor_name,
              truck.vendor_city,
              truck.vendor_phone_num,
              truck.vendor_email,
              truck.name,
              truck.license_plate,
              truck.size_ref,
              truck.make,
            ];
          });

          console.log('unassigned_trucks', unassigned_trucks);
          this.setState({
            inventoryTableData: unassigned_trucks,
            dataToExport: unassigned_trucks, 
            cities: Array.from(new Set(response.data.cities.map((c) => c.city.trim()))),
            makes: Array.from(new Set(response.data.makes.map((m) => m.make.trim()))),
            isLoading: false,
            noDataFound: unassigned_trucks.length === 0 
          });
        })
        .catch((err) => {
          this.setState({ isLoading: false });
          console.log(err);
        })
    );
  };

  updateInventoryTableData = (data) => {
    this.setState({ ...this.state, dataToExport: data });
  }

  updateSearchValue = (data) => {
    this.setState({ ...this.state, searchValue: data });
  }
  
  // Handle city change and re-fetch data from the backend
  handleCityChange = (selectedOptions) => {
    this.setState({ selectedCities: selectedOptions || [] }, this.getInventoryData);  // Store selected cities as an array
  };

  // Handle make change and re-fetch data from the backend
  handleMakeChange = (e) => {
    this.setState({ selectedMake: e.target.value }, this.getInventoryData);
  };

  // Clear filters and reset dropdowns
  handleClearFilters = () => {
    this.setState(
      { selectedCities: [], selectedMake: "" }, // Reset filters
      this.getInventoryData // Fetch updated data without filters
    );
  };

  // Export the displayed data to CSV
  exportCSV = () => {
    const { dataToExport } = this.state;
  
    if (!dataToExport || !Array.isArray(dataToExport) || dataToExport.length === 0) {
      console.error("No data available for export");
      return;
    }
  
    // Add "Vendor Email" to the headers specifically for the CSV export, excluding the "id" header
    const exportHeaders = [
      "Vendor Name",
      "Vendor City",
      "Vendor Phone Number",
      "Vendor Email",
      "Truck Name",
      "License Plate",
      "Size Ref",
      "Make"
    ];
  
    // Combine headers and data into a CSV format
    const csvRows = [];
    const headers = exportHeaders.join(",");
    csvRows.push(headers);
    console.log('headers', headers);
  
    // Map the data into rows, excluding the first column (id)
    dataToExport.forEach(row => {
      const csvRow = row.map(item => `"${item}"`).join(",");
      csvRows.push(csvRow);
    });
  
    // Create a Blob from the CSV string
    const csvContent = csvRows.join("\n");
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.setAttribute("download", "inventory_data.csv");
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  

  inventoryTableHeaders = ["id", "Vendor Name", "Vendor City", "Vendor Phone Number", "Vendor Email", "Truck Name", "License Plate", "Size Ref", "Make"];

  render() {
    const { isLoading, inventoryTableData, noDataFound, cities, selectedCities } = this.state;

    // Format cities as options for react-select
    const cityOptions = cities.map(city => ({ value: city, label: city }));

    let buttons = [
      {
        display: "View",
        onClickHandler: (index, id) => {
          this.props.history.push(`/dashboard/admin/drive/vendor/edit/${id}`);
        }
      }
    ]
    return (
      <Fragment>
        <Loading loading={isLoading} label="Loading Available Inventory..." />
        <Helmet>
          <title>Boxi Admin | Available Inventory</title>
        </Helmet>
        <Row className="mb-4">
          <Col lg="12">
            <Row className="d-flex justify-content-between align-items-center mb-2 mr-1">
              <Title style={{ paddingLeft: 20, marginBottom: 0 }}>Available Inventory</Title>
              <button className="btn btn-primary" onClick={this.exportCSV}>Export CSV</button>
            </Row>
          </Col>
          <Col lg="12">
          <Row className="d-flex justify-content-end align-items-center mb-2">
            <Col lg="6">
              {/* Implement multi-selectable dropdown for cities */}
              <Select
                id="cityDropdown"
                name="city"
                value={selectedCities}
                onChange={this.handleCityChange}
                options={cityOptions}
                isMulti  // Enable multi-selection
                isClearable
                placeholder="Search Cities"
                styles={{
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
              />
            </Col>
          </Row>
            {noDataFound ? (
              <div className="text-center">No data found</div>
            ) : (
              <Table
                id="inventory-table"
                title="Inventory"
                headers={this.inventoryTableHeaders}
                data={inventoryTableData}
                colors={["#46c768", "#0da661"]}
                buttons={buttons}
                updateInventoryTableData={this.updateInventoryTableData}
                updateSearchValue={this.updateSearchValue}
                searchValue={this.state.searchValue}
                selectedCities={this.state.selectedCities.length}
                // searchOnly={true}
              />
            )}
          </Col>
        </Row>
      </Fragment>
    );
  }
}

export default withRouter(InventoryPage);
